export default __webpack_public_path__ + "static/v-itamin-d-box@2x-f70fa6d64996e1d658bb532e5d4517a9.png";